"use strict";
// Forms — lead capture that writes to the app's own D1.
//
// Its table (`form_submissions`) predates the plugin system and is
// grandfathered: it keeps its name and stays in the AI's migration history.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMS_PLUGIN = void 0;
exports.FORMS_PLUGIN = {
    id: 'forms',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Forms',
    description: 'Contact forms, newsletter signups, waitlists. Submissions land in your dashboard.',
    icon: 'i-ph:note-pencil',
    surfaces: ['web-app'],
    agentCard: 'Forms: contact/newsletter/waitlist capture posting to /api/forms/:formId (skills/forms.md).',
    emits: {
        'forms.submitted': { major: 1, description: 'A visitor submitted a form.' },
    },
    targets: {
        'web-app': {
            skills: ['forms'],
            lockedPaths: ['frontend/worker/dunea/platform.ts', 'frontend/worker/dunea/schema.ts'],
        },
    },
};
